export const AUDIO_PRECACHE_NAME = 'audio';
export const VIDEO_PRECACHE_NAME = 'video';
export const IMAGES_PRECACHE_NAME = 'images';

// mapbox-gl caps its own `mapbox-tiles` bucket at 500 entries and self-prunes
// the oldest, so we mirror vector tiles into a bucket it never touches. The
// service worker fills it and serves from it offline (see service-worker.js).
export const MAPBOX_PRECACHE_NAME = 'mapbox-general';
export const TILES_PRECACHE_NAME = 'mapbox-tiles';
export const TILES_OFFLINE_PRECACHE_NAME = 'mapbox-tiles-offline';
